<template>
  <div class="hot-taglist-base section basic-section">
    <div class="tag-icon"><img src="/static/img/icons/ic_tag.svg"></div>
    <tag-list
      :tag-list="hotTaglist"
      :link-enable="true"
    />
  </div>
</template>

<script>
import TagList from '@/utvStore/components/partials/TagList';
export default {
  name: 'HotTagList',
  components: {
    TagList
  },
  data(){
    return {}
  },
  props: {
    hotTaglist: {
      type: Array,
      default() {
        return []
      }
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.hot-taglist-base {
  padding: 12px 20px;
  display: flex;
  align-items: flex-start;
  max-width: 580px;
  margin: auto;
  line-height: 1.2;
  /deep/ ul {
    flex: 1;
    & > li {
      font-size: 12px;
      margin-right: 4px;
    }
  }
  .tag-icon {
    width: 17px;
    height: 17px;
    margin-right: 6px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/HotTagList.vue